import { computed } from 'vue';

import type { DocumentRevision } from '@/entities/Document';
import { useDocumentSelection } from '@/features/Document';

interface UseDocumentTableSelectionOptions {
  revisions: () => DocumentRevision[];
}

export function useDocumentTableSelection(options: UseDocumentTableSelectionOptions) {
  const { revisions } = options;

  const {
    isDocumentSelected,
    toggleDocumentSelection,
    deselectAllDocuments,
  } = useDocumentSelection();

  const handleToggleSelection = (id: number) => {
    toggleDocumentSelection(id);
  };

  const handleToggleAll = () => {
    const allCurrentlySelected = revisions().every((rev: DocumentRevision) =>
      isDocumentSelected(rev.id)
    );
    if (allCurrentlySelected) {
      deselectAllDocuments();
    } else {
      revisions().forEach((rev: DocumentRevision) => {
        if (!isDocumentSelected(rev.id)) {
          toggleDocumentSelection(rev.id);
        }
      });
    }
  };

  const allSelected = computed(
    () =>
      revisions().length > 0 &&
      revisions().every((rev: DocumentRevision) => isDocumentSelected(rev.id))
  );

  return {
    handleToggleSelection,
    handleToggleAll,
    allSelected,
  };
}

